(ns dashboard.views.browser-extension.client-environments.config)

(def view-id :route.view/extension-client-environments)
